<template>
  <aside id="explore-sidebar" :class="{ fullView: filterSidebarSized }">
    <b-row>
      <b-col class="d-flex">
        <b-btn v-if="filterSidebarSized" variant="outline-secondary" @click="toggleExploreSidebarSize">
          <i class="far fa-window-maximize"></i>
        </b-btn>
        <b-btn v-else variant="outline-secondary" @click="toggleExploreSidebarSize">
          <i class="fas fa-columns"></i>
        </b-btn>
        <b-button-group class="ml-auto">
          <b-btn @click="saveFilterBuilderToolsState('auto')" size="sm" variant="outline-secondary">
            Query Editor <i :class="filterBuilderTools? 'far fa-check-square':'far fa-square'" />
          </b-btn>
          <b-btn @click="saveFilterListState()" size="sm" variant="outline-secondary">
            Filters <i :class="filterList? 'far fa-check-square':'far fa-square'" />
          </b-btn>
          <!--<b-btn @click="saveFilterWikiState()" size="sm" variant="outline-secondary">
            Wikis <i :class="filterWikis? 'far fa-check-square':'far fa-square'" />
          </b-btn>-->
          <b-btn @click="saveFilterAiState()" size="sm" variant="outline-secondary">
            Filters Builder <i :class="filterAi? 'far fa-check-square':'far fa-square'" />
          </b-btn>
        </b-button-group>
      </b-col>
    </b-row>
    <b-row v-if="filterFocused">
      <b-col>
        <div class="whitecard mt-2">
          <h3>Active Filter</h3>
          <b-button-group class="d-flex">
            <b-btn
              v-b-popover.hover.top="'Jump to ' + filterFocusedType"
              variant="outline-secondary"
              size="sm"
              @click="jumpToFilterFocused"
            >
              <i class="fa fa-crosshairs" />
              Active {{ filterFocusedType }}: {{ filterFocused.name }}
            </b-btn>
            <b-btn
              v-b-popover.hover.top="'Disable ' + filterFocusedType"
              variant="outline-secondary"
              size="sm"
              @click="filterFocus({ filter: null, type: filterFocusedType })"
            >
              <i class="fa fa-filter" /> Disable
            </b-btn>
            <b-btn
              v-b-popover.hover.top="'Exapnd ' + filterFocusedType"
              variant="outline-secondary"
              size="sm"
              @click="reverseQuery(filterFocused)"
            >
              <i class="fa fa-expand" /> Expand
            </b-btn>
          </b-button-group>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col :cols="filterSidebarSized? 6:12" :class="{'pr-1':filterSidebarSized}">
        <Annotations v-if="filterBuilderTools" :layout="filterSidebarSized" ref="detailView" @editBlock="saveBlock"></Annotations>
        <IndicesDetail v-if="filterBuilderTools" :layout="filterSidebarSized" :indice="activeIndice"></IndicesDetail>
        <div
          class="whitecard mt-2"
          v-if="!annotationsVisible && !indiceDetailVisible && filterBuilderTools"
        >
          <b-form @submit.prevent="submit">
            <template v-if="updateBtnVisible">
              <h3>Update New Filter</h3>
            </template>
            <template v-else>
              <h3>Add New Filter</h3>
            </template>

            <div class="d-flex justify-content-start">
              <b-dropdown size="sm" split text="Building Blocks" class="mr-1">
                <b-dropdown-item
                  v-for="(option, i) in buildingBlockOptions"
                  :key="i"
                  @click="setBlock(option.type)"
                >
                  {{ option.name }}
                </b-dropdown-item>
              </b-dropdown>
              <!-- Operators -->
              <div
                v-for="(item, i) in buttons"
                :key="i"
                class="query-builder-item"
                :class="['type-' + item.type, 'value-' + item.value]"
                @click="addOperatorToQuery(item.value)"
              >
                <span>{{ item.display }}</span>
              </div>
            </div>

            <div class="clearfix"></div>

            <div
              class="mt-2 mb-2 query-builder halfHeight form-control form-control-lg"
              :class="{
                valid: queryValid === true,
                invalid: queryValid === false,
                fullHeight: filterSidebarSized
              }"
            >
              <h6>
                <b-alert variant="warning" :show="mergeConflicts"
                  >Conflict: Newer version found:<br /><br />
                  <b-btn
                    size="sm"
                    class="p-1"
                    variant="outline-secondary"
                    @click="discardNew()"
                    >Discard New</b-btn
                  >
                  &nbsp;&nbsp;&nbsp;
                  <b-btn
                    size="sm"
                    class="p-1"
                    variant="outline-secondary"
                    @click="discardOld()"
                    >Discard Old</b-btn
                  >
                </b-alert>
              </h6>
              <draggable
                :list="ttcDropped"
                :group="{ name: 'annotations', pull: true, put: true }"
                :sort="true"
                class="builder-canvas halfHeight"
                :class="{ fullHeight: filterSidebarSized }"
                @change="draggedSomething"
              >
                <div
                  v-for="item in form.query"
                  :key="item.id"
                  class="query-builder-item canvas-item"
                  :class="[
                    'type-' + item.type + checkItem(item.value),
                    'value-' + item.value,
                  ]"
                >
                  <div class="action-buttons">
                    <b-btn variant="link" @click="removeItemFromQuery(item)">
                      <i class="fa fa-times"></i>
                    </b-btn>
                    <b-btn
                      v-if="item.type === 'ttc-concept'"
                      variant="link"
                      @click="addToAnnotations(item)"
                    >
                      <i class="fa fa-edit"></i>
                    </b-btn>
                    <b-btn
                      v-if="
                        item.type !== 'ttc-concept' &&
                        item.type !== 'operator' &&
                        item.type !== 'filter'
                      "
                      variant="link"
                      @click="addToIndicesDetail(item)"
                    >
                      <i class="fa fa-edit"></i>
                    </b-btn>
                  </div>
                  <span
                    v-if="item.type !== 'operator'"
                    :id="'popover-' + item.id"
                    class="small font-weight-bolder"
                    >{{ item.typeName }}<br
                  /></span>
                  <span v-if="item.type !== 'operator'" class="cnames">
                    {{ item.display }}
                  </span>
                  <span v-if="item.type === 'operator'" class="cnames-op">
                    {{ item.display }}
                  </span>
                  <b-popover
                    triggers="click"
                    placement="top"
                    :target="'popover-' + item.id"
                  >
                    <template v-slot:title>{{ item.type | ucFirst }}</template>
                    <p v-if="item.type !== 'operator'" class="mb-2">
                      {{ item.display }}
                    </p>

                    <div class="clearfix"></div>
                  </b-popover>
                </div>
              </draggable>
            </div>
            <b-container>
            <b-row class="d-flex justify-content-between">
              <b-col cols="8">
                <b-btn-group>
                  <b-btn variant="outline-secondary" size="sm" @click="addToFocus()"
                    >Focus</b-btn
                  >
                  <b-btn variant="outline-secondary" size="sm" @click="clearFilter()"
                    >Clear Filter</b-btn
                  >
                </b-btn-group>
              </b-col>
              <b-col cols="4" class="text-right">
                <b-btn
                  v-if="validForSave"
                  variant="primary"
                  size="sm"
                  type="submit"
                  :disabled="!queryValid"
                >
                  <template v-if="updateBtnVisible"> Update filter </template>
                  <template v-else> Save filter </template>
                </b-btn>
                <b-btn
                  v-else
                  variant="primary"
                  size="sm"
                  @click="updateUploadedFilter()"
                >
                  Update inValid filter
                </b-btn>
              </b-col>
            </b-row>
            </b-container>
          </b-form>
        </div>
      </b-col>
      <b-col :cols="filterSidebarSized? 6:12" :class="{'pl-1':filterSidebarSized}">
        <b-card v-if="filterList || filterAi" no-body class="card-tabs inner-tabs whitecard mt-2">
          <b-tabs v-model="activeTab" card>
            <b-tab v-if="filterList" title="Filters" lazy>
              <b-row>
                <b-col class="d-flex justify-content-between">
                  <b-button-group>
                    <b-button
                      @click="selectAllFilters(true)"
                      size="sm"
                      ><i class="far fa-check-square"></i> Select All</b-button
                    >
                    <b-button v-if="exportFilters.length" @click="selectAllFilters(false)" size="sm"
                      ><i class="fas fa-check-square"></i> Undo Selection</b-button
                    >
                  </b-button-group>
                  <b-button-group>
                    <b-button v-if="filtersToExport.length" 
                          size="sm"
                          variant="outline-secondary"
                          @click="deleteSelectedFilter()"
                      ><i class="fas fa-trash"></i> Delete</b-button
                    >
                    <xlsx-workbook>
                      <xlsx-sheet
                        :collection="exportFilters"
                        :sheet-name="'Filters'"
                      />
                      <xlsx-download>
                        <b-btn
                          size="sm"
                          variant="outline-secondary"
                          :disabled="filtersToExport.length === 0"
                        >
                          <i class="fa fa-download" /> Download Selected Filters
                        </b-btn>
                      </xlsx-download>
                    </xlsx-workbook>
                  </b-button-group>
                </b-col>
              </b-row>
              <div
                class="alert alert-info small px-2 py-1 my-2"
                v-if="filtersToExport.length > 1"
              >
                <i class="fas fa-info-circle" />
                During export, all the filters are flattened using OR Logic.
              </div>
              <div v-if="filters" v-show="showFilters" class="filters mt-2">
                <p v-if="filters.length === 0" class="m-0 small">
                  No filters created yet
                </p>
                <FilterCategory
                  v-for="filter in filters"
                  :key="filter._id"
                  class="mb-1"
                  :filter="filter"
                >
                </FilterCategory>
              </div>
              <FilterItemModal
                :create="false"
                :filter="modalFilter"
                :newfilter="activeFilter"
                title="Edit Modal"
                @clearBuilder="clearFilter"
                @handleMisMatched="handleMisMatched"
              ></FilterItemModal>

              <FilterCategoryModal
                :create="false"
                :category="modalCategory"
              ></FilterCategoryModal>
            </b-tab>
            <!--
            <b-tab v-if="filterWikis" title="Wikipedia" lazy>
              <div v-if="wikis" v-show="showWikis" class="filters halfHeight" :class="{ 'fullHeight':filterSidebarSized }">
                <p v-if="wikis.length === 0" class="m-0 small">
                  No Wikipedia Categories found
                </p>
                <WikiCategory
                    v-for="wiki in wikis"
                    v-once
                    :key="wiki._id"
                    class="mb-1"
                    :wiki-category="wiki"
                    @wikiToFilter="wikiToFilter"
                  >
                </WikiCategory>
              </div>
            </b-tab>
            -->
            <b-tab v-if="filterAi" title="Filter Builder" lazy>
              <auto-classification v-if="!importedFilters.length" />
              <template v-if="classificationStage<1">
                <p class="mt-4" v-if="!importedFilters.length">Or upload previously generated filters</p>
                <b-input-group v-if="!importedFilters.length">
                  <b-form-file v-model="file"></b-form-file>
                  <b-input-group-append>
                    <b-btn @click="uploadFilter" variant="outline-secondary">
                      <b-spinner v-if="uploading" small />
                      Import
                    </b-btn>
                  </b-input-group-append>
                </b-input-group>
              </template>
              <template v-if="importedFilters.length">
                <b-button-group v-if="importedFilters.length">
                    <b-btn @click="resetImport()" size="sm" variant="outline-secondary">
                      <i class="fa fa-arrow-left" /> 
                      Clear &amp; Reset
                    </b-btn>
                    <b-btn @click="markAllAsSelected()" size="sm" variant="outline-secondary">
                      <i class="fas fa-check-square"></i>
                      Select All
                    </b-btn>
                    <b-btn @click="markAsSelected(null)" size="sm" variant="outline-secondary" :disabled="!selectedFiltersForImport.length">
                      <i class="fas fa-eraser"></i>
                      Clear Selection
                    </b-btn>
                    <b-btn @click="saveSelectedImpFilters()" size="sm" variant="outline-secondary" :disabled="!selectedFiltersForImport.length">
                      <i class="fas fa-save"></i>
                      Save as Filter
                    </b-btn>
                </b-button-group>
                <b-overlay :show="uploading" rounded="sm">
                <div class="imported-filters">
                  <div
                    class="d-flex flex-column flex-wrap cat"
                    v-for="(category, n) in importedFilters"
                    :key="n"
                  >
                    <div class="d-flex justify-content-between cat-row">
                      <span class="d-flex align-items-center">{{
                        category.name
                      }}</span>
                      <!--<b-button
                        variant="outline-secondary"
                        size="sm"
                        class="px-2 py-1 ml-auto"
                        @click="markAsSelected(category)"
                        >
                        <i v-if="markedAsSelected(category.id)" class="fa fa-check"></i>
                        <i v-else class="far fa-square"></i>
                      </b-button>-->
                      <b-button
                        v-b-toggle="'collapse-' + n"
                        variant="outline-secondary"
                        size="sm"
                        class="px-2 py-1"
                      >
                        <i class="fa fa-caret-down" />
                      </b-button>
                    </div>
                    <div class="collapsed-filter pl-1">
                      <b-collapse :id="'collapse-' + n" class="collapsed-subfilter">
                        <div
                          class="d-flex flex-column flex-wrap mb-1"
                          v-for="(subcat, m) in category.children"
                          :key="m"
                        >
                          <div class="d-flex justify-content-between">
                            <span class="d-flex align-items-center">- {{
                              subcat.name
                            }}</span>
                            <!--<b-button
                              variant="outline-secondary"
                              size="sm"
                              class="px-2 py-1 ml-auto"
                              @click="markAsSelected(subcat)"
                              >
                              <i v-if="markedAsSelected(subcat.id)" class="fa fa-check"></i>
                              <i v-else class="far fa-square"></i>
                            </b-button>-->
                            <b-button
                              v-b-toggle="'l2collapse-' + n + '-' + m"
                              variant="link-dark"
                              size="sm"
                              class="px-2 py-1"
                            >
                              <i class="fa fa-caret-down" />
                            </b-button>
                          </div>
                          <b-collapse :id="'l2collapse-' + n + '-' + m" class="mt-2">
                            <b-list-group>
                              <b-list-group-item
                                v-for="(filter, o) in subcat.children"
                                :key="o"
                                class="d-flex"
                              >
                                <span class="d-flex align-items-center">
                                  {{ filter.name }} ({{ filter.matched }}/{{
                                    filter.matched + filter.unmatched
                                  }})
                                </span>
                                <b-button-group class="ml-auto">
                                  <b-button
                                    v-if="filter.matched"
                                    variant="outline-secondary"
                                    size="sm"
                                    class="px-2 py-1"
                                    @click="markAsSelected(category, subcat, filter, n, m, o)"
                                  >
                                    <i v-if="markedAsSelected(filter.id)" class="fa fa-check"></i>
                                    <i v-else class="far fa-square"></i>
                                  </b-button>
                                  <b-button
                                    v-if="
                                      filter.matched ===
                                      filter.matched + filter.unmatched
                                    "
                                    variant="outline-secondary"
                                    size="sm"
                                    class="px-2 py-1"
                                    @click="
                                      saveImportedFilter(category, subcat, filter)
                                    "
                                  >
                                    <i class="fa fa-save" />
                                  </b-button>
                                  <b-button
                                    v-else-if="filter.matched"
                                    variant="outline-secondary"
                                    size="sm"
                                    class="px-2 py-1"
                                    @click="saveInvalidFilter(n, m, o)"
                                  >
                                    <i class="fa fa-save" />
                                  </b-button>
                                  <b-button
                                    v-else
                                    variant="outline-secondary"
                                    size="sm"
                                    class="px-2 py-1"
                                    disabled
                                  >
                                    <i class="fa fa-save" />
                                  </b-button>
                                  <b-button
                                    variant="outline-secondary"
                                    size="sm"
                                    class="px-2 py-1"
                                    @click="parseImportedFilter(filter, n, m, o)"
                                  >
                                    <i class="fa fa-edit" />
                                  </b-button>
                                </b-button-group>
                              </b-list-group-item>
                            </b-list-group>
                          </b-collapse>
                        </div>
                      </b-collapse>
                    </div>
                  </div>
                </div>
                </b-overlay>
              </template>
            </b-tab>
          </b-tabs>
        </b-card>
      </b-col>
    </b-row>

    <!-- Modals for new filter -->
    <ConceptSearchModal @addToQuery="addToQuery"></ConceptSearchModal>

    <FieldSearchModal @addToQuery="addToQuery"></FieldSearchModal>

    <IndiceSearchModal
      :indice="modalIndice"
      @addToQuery="addToQuery"
    ></IndiceSearchModal>

    <FilterSearchModal @addToQuery="addToQuery"></FilterSearchModal>

    <ThemeSearchModal @addToQuery="addToQuery"></ThemeSearchModal>

    <NewFilterModal
      :filter="modalFilter"
      title="New filter"
      @clearBuilder="clearFilter"
    ></NewFilterModal>
  </aside>
</template>

<script>
import $ from "jquery";
import _ from "lodash";
import { XlsxDownload, XlsxSheet, XlsxWorkbook } from "vue-xlsx";
import moment from "moment";
import Vue from "vue";
import virtualList from "vue-virtual-scroll-list";
import draggable from "vuedraggable";
import { mapActions, mapGetters, mapState } from "vuex";
import { EventBus } from "@/eventBus";
import ValidateQuery from "@/helpers/ValidateQuery";
import DataSettings from "@/helpers/DataSettings";
import AutoClassification from "../ExploreFilters/AutoClassification.vue";
import {
  filterOutIdName,
  preFilter,
  prepFilter,
  getFiltId,
  getParentId,
  addCounts
} from "../../../helpers/PrepFilters";
import InitApi from "../Shared/InitApi";
import Annotations from "./Annotations";
import FilterCategory from "./FilterCategory";
import FilterCategoryModal from "./FilterCategoryModal";
import FilterItemModal from "./FilterItemModal";
import IndicesDetail from "./IndicesDetail";
import ConceptSearchModal from "./Modals/ConceptSearchModal";
import FieldSearchModal from "./Modals/FieldSearchModal";
import FilterSearchModal from "./Modals/FilterSearchModal";
import IndiceSearchModal from "./Modals/IndiceSearchModal";
import ThemeSearchModal from "./Modals/ThemeSearchModal";
import NewFilterModal from "./NewFilterModal";
//import WikiCategory from "./WikiCategory";

export default {
  name: "ExploreSidebar",
  components: {
    FieldSearchModal,
    Annotations,
    IndicesDetail,
    FilterCategory,
    FilterCategoryModal,
    FilterItemModal,
    NewFilterModal,
    //WikiCategory,
    virtualList,
    ConceptSearchModal,
    FilterSearchModal,
    IndiceSearchModal,
    ThemeSearchModal,
    draggable,
    XlsxWorkbook,
    XlsxSheet,
    XlsxDownload,
    AutoClassification
  },
  extends: InitApi,
  data() {
    return {
      //filtersTemp: [],
      filterCount: 0,
      mergeConflicts: false,
      exportFilters: [],
      impFiltInEdit: null,
      unExportable: 0,
      file: null,
      uploading: false,
      activeTab: 0,
      activeBlock: null,
      activeFilter: null,
      modalFilter: null,
      modalCategory: null,
      showFilters: true,
      showWikis: true,
      modalIndice: null,
      activeIndice: null,
      annotationsVisible: false,
      indiceDetailVisible: false,
      ttcDropped: [],
      updateBtnVisible: false,
      buildingBlockOptions: [],
      form: {
        search: null,
        name: null,
        query: [],
      },
      fields: {
        name: null,
        parentCategory: null,
      },
      buttons: [
        {
          type: "operator",
          value: "AND",
          display: "AND",
        },
        {
          type: "operator",
          value: "OR",
          display: "OR",
        },
        {
          type: "operator",
          value: "NOT",
          display: "NOT",
        },
        {
          type: "operator",
          value: "bracket_open",
          display: "(",
        },
        {
          type: "operator",
          value: "bracket_close",
          display: ")",
        },
      ],
      selectedFiltersForImport: []
    };
  },
  computed: {
    ...mapGetters(["ttcLookup"]),
    ...mapState({
      apiReady: state => state.api.apiReady,
      documentSelection: state => state.document.documentSelection,
      filterElement: state => state.filter.filterElement,
      filterFocused: state => state.filter.filterFocused,
      filterFocusedType: state => state.filter.filterFocusedType,
      filterQuery: state => state.filter.filterQuery,
      filters: state => state.filter.filters,
      indices: state => state.ttc.indices,
      loading: state => state.api.loading,
      metas: state => state.ttc.metas,
      queryView: state => state.visualization.queryView,
      selectedElement: state => state.visualization.selectedElement,
      subsetFilter: state => state.filter.subsetFilter,
      ttc: state => state.ttc.ttc,
      wikis: state => state.filter.wikis,
      filtersToExport: state => state.filter.filtersToExport,
      importedFilters: state => state.filter.importedFilters,
      filterDuplicates: state => state.filter.filterDuplicates,
      importedFile: state => state.impexp.importedFile,
      filterSidebarSized: state => state.layout.filterSidebarSized,
      filterBuilderTools: state => state.layout.filterBuilderTools,
      //filterWikis: state => state.layout.filterWikis,
      filterAi: state => state.layout.filterAi,
      filterList: state => state.layout.filterList,
      classificationStatus: (state) => state.classification.classificationStatus,
      classificationStage: (state) => state.classification.currentStage,
    }),
    queryValid() {
      return ValidateQuery.isValid(this.form.query);
    },
    validForSave() {
      return ValidateQuery.haveAlienConcepts(this.form.query);
    },
    validfilters() {
      return this.filters.filter(f => !f.name.includes('_del') && f._id.includes('invalid') && f.name !== 'tempmaincat')
    }
  },
  watch: {
    activeTab(newValues) {
      localStorage.activeTab = newValues;
    },
    filterElement(newValues) {
      let filtElem = newValues.element;
      if (newValues.type === "new") {
        this.clearFilter(true);
      }
      if (!Array.isArray(filtElem)) {
        filtElem = [filtElem];
      } else {
        if (filtElem.length === 1) {
          filtElem = filtElem[0];
        }
      }
      this.parseQueryElements(filtElem, false);
      this.loadFreshDocs();
    },
    filtersToExport(newValues) {
      this.getFilters(newValues);
    },
    filters(val){
      //DataSettings.setSettings("focus.lastQuery", val.filter(f => f.name !== "tempmaincat" ));
      this.countFilters();
    }
  },
  mounted() {
    this.checkImport();
    this.initBuildingBlockOptions();
    this.initQueryBuilder();
    this.invokeLsValues();
    this.loadFilters();
    EventBus.$on("editFilter", (filter) => {
      this.updateBtnVisible = true;
      this.reverseQuery(filter);
      this.activeFilter = filter;
      this.saveFilterBuilderToolsState("open");
    });
    //EventBus.$on("editBlock", topics => {
    //  this.saveBlock(topics);
    //});
    EventBus.$on("editIndice", (indices) => {
      this.saveIndice(indices);
    });
    EventBus.$on("closeIndice", (val) => {
      val === "close"
        ? (this.indiceDetailVisible = false)
        : (this.indiceDetailVisible = true);
    });
    EventBus.$on("toggleBuilder", (val) => {
      val === "close"
        ? (this.annotationsVisible = false)
        : (this.annotationsVisible = true);
    });
    EventBus.$on("editCategory", (category) => {
      this.modalCategory = category;
      this.$bvModal.show("modal-category");
    });
  },
  beforeDestroy() {
    EventBus.$off("editFilter");
    EventBus.$off("editBlock");
    EventBus.$off("editIndice");
    EventBus.$off("closeIndice");
    EventBus.$off("toggleBuilder");
    EventBus.$off("editCategory");
    this.saveQueryView({ query: this.form.query });
  },
  destroyed() {
    //this.clearFilter();
    //this.saveFilterSidebarState(false);
  },
  methods: {
    ...mapActions([
      "filterFocus",
      "loadFilters",
      "saveFilter",
      "saveCategory",
      "saveFilterQuery",
      "saveSubsetFilter",
      "saveQueryView",
      "uploadFilters",
      "saveImpFilters",
      "saveSecondaryFilter",
      "updateSecondaryFilter",
      "updateImportedFilters",
      "addFiltersToExport",
      "saveImportFile",
      //"loadFiltersTemp",
      "saveFilterSidebarSize",
      "saveBulkImportedFilters",
      "loadAnimStart",
      "loadAnimEnd",
      "saveLoadingStep",
      "saveFilterSidebarState",
      "saveFilterBuilderToolsState",
      "saveFilterAiState",
      "saveFilterWikiState",
      "saveFilterListState",
      "deleteBulkFilter"
    ]),
    async checkImport() {
      if(this.importedFile && !this.importedFile.status.filters){
        await this.createCategories();
        await this.createSubCategories();
        this.createFilters();
        let imported = this.importedFile;
        imported.status.filters = true;
        this.saveImportFile(imported)
      }
    },
    createCategories(){
      let cats = [];
      return new Promise((resolve, reject) => {
        
          this.importedFile.filters.forEach((cat) => {
            let filter = {
              name: cat.name,
              type: "category"
            }
            this.saveFilter({
              filter: filter
            }).then((res) => {
              cats.push(res)
              if(cats.length === this.importedFile.filters.length){
                resolve()
              }
            })
          })
        
      })
    },
    createSubCategories(){
      let subCats = [];
      return new Promise((resolve, reject) => {

          this.importedFile.filters.forEach((cat, i) => {
            this.loadFilters().then(() => {
              let catid = this.filters.find(f => f.name === cat.name)._id;
              cat.children.forEach((sub) => {
                let filter = {
                  name: sub.name,
                  type: "subcategory"
                }
                this.saveFilter({
                  filter: filter,
                  category: { _id: catid }
                }).then((res) => {
                  subCats.push(res)
                })
              })
              if(this.importedFile.filters.length === i+1){
                resolve()
              }
            })
          })

      })
    },
    createFilters(){
          this.loadFilters().then(() => {
            this.importedFile.filters.forEach((cat, i) => {
              let catid = this.filters.find(f => f.name === cat.name)._id;
              cat.children.forEach((sub) => {
                let subcatid = this.filters[i].children.find(s => s.name === sub.name)._id;
                sub.children.forEach((filt) => {
                  let filter = {
                    name: filt.name,
                    type: "filter",
                    query: filt.rawquery
                  }
                  this.saveFilter({
                    filter: filter,
                    category: { _id: catid },
                    subcategory: { _id: subcatid }
                  }).then((res) => {
                    console.log("filter Added")
                  })
                })
              })
            })
          })  
    },
    resetImport(){
      this.saveImpFilters({ filters: { categories: [] } });
    },
    async prepareFiltersImport(){
      this.uploading = true;
      this.selectedFiltersForImport = [];
      return new Promise((resolve) => {
        this.importedFilters.forEach((c, ci) =>{
          c.children.forEach((s, si) => {
            s.children.forEach((f, fi) => {
              this.selectedFiltersForImport.push({
                id: f.id,
                cat: c,
                subcat: s,
                filter: f,
                ci: ci,
                si: si,
                fi: fi
              });
            })
          })
          if(this.importedFilters.length > ci){
            resolve();
            this.uploading = false;
          }
        })
      })
    },
    async markAllAsSelected(){
      await this.prepareFiltersImport();
    },
    markAsSelected(cat, sub, filt, m, n, o){
      if(filt){
        const index = _.findIndex(this.selectedFiltersForImport, { 'id':filt.id })
        if(index > -1){
          this.selectedFiltersForImport.splice(index, 1);
        }
        else{
          this.selectedFiltersForImport.push({
            id: filt.id,
            cat: cat,
            subcat: sub,
            filter: filt,
            ci: m,
            si: n,
            fi: o
          });
        }
      }
      else{
        this.selectedFiltersForImport = [];
      }
    },
    markedAsSelected(id){
      return _.findIndex(this.selectedFiltersForImport, { 'id':id }) > -1? true:false
    },
    initBuildingBlockOptions() {
      let options = [
        { type: "filter", name: "Filter" },
        { type: "ttc-concept", name: "Concept" },
        { type: "field", name: "Field" },
      ];

      options.push(
        ...this.indices.map((i) => {
          return { type: i.type, name: i.name };
        })
      );

      this.buildingBlockOptions = _.orderBy(options, "name");
    },
    initQueryBuilder() {
      this.form.query = this.queryView;
    },
    invokeLsValues() {
      localStorage.activeTab
        ? (this.activeTab = Number(localStorage.activeTab))
        : 0;
    },
    uploadFilter() {
      this.uploading = true;
      const formData = new FormData();
      formData.append("file", this.file);
      this.uploadFilters(formData).then((imports) => {
        let imported = addCounts(imports);
        this.saveImpFilters({ filters: imported });
        this.uploading = false;
      });
    },
    updateUploadedFilter() {
      if ("id" in this.activeFilter && this.activeFilter.id.includes("imp")) {
        let imports = this.importedFilters;
        imports[this.impFiltInEdit.category].children[
          this.impFiltInEdit.subcategory
        ].children[this.impFiltInEdit.filter].rawquery = preFilter(
          this.form.query
        );
        this.updateImportedFilters({ categories: imports }).then((res) => {
          let imported = addCounts(res);
          this.saveImpFilters({ filters: imported });
          this.clearFilter();
        });
      } else {
        let filt = getParentId(this.filters, this.activeFilter._id);
        let rquery = preFilter(this.form.query, false);
        let crquery = this.cleanQuery(rquery);
        if (crquery.length > 0 && !("linkedfilter" in this.activeFilter)) {
          let payloadFilter = {
            name: this.activeFilter.name,
            type: "filter",
            query: crquery,
            updated_date: null,
          };
          this.saveFilter({
            filter: payloadFilter,
            category: { _id: filt.cat },
            subcategory: { _id: filt.subCat },
          }).then((res) => {
            let lfilter = res._id;
            this.updateSecondaryFilter({
              name: this.activeFilter.name,
              rawquery: rquery,
              type: this.activeFilter.type,
              category: filt.cat,
              subcategory: filt.subCat,
              _id: filt.filt,
              linkedfilter: lfilter,
            }).then(() => {
              this.clearFilter();
              this.$toasted.show("Filter updated");
            });
          });
        } else if (crquery.length > 0 && "linkedfilter" in this.activeFilter) {
          this.updateSecondaryFilter({
            name: this.activeFilter.name,
            rawquery: rquery,
            type: this.activeFilter.type,
            category: filt.cat,
            subcategory: filt.subCat,
            _id: filt.filt,
            linkedfilter: this.activeFilter.linkedfilter,
          }).then(() => {
            let payloadFilter = {
              _id: this.activeFilter.linkedfilter,
              name: this.activeFilter.name,
              type: "filter",
              query: crquery,
              updated_date: null,
            };
            this.saveFilter({
              filter: payloadFilter,
              category: { _id: filt.cat },
              subcategory: { _id: filt.subCat },
            }).then((res) => {
              this.clearFilter();
              this.$toasted.show("Filter updated");
            });
          });
        } else {
          this.updateSecondaryFilter({
            name: this.activeFilter.name,
            rawquery: rquery,
            type: this.activeFilter.type,
            category: filt.cat,
            subcategory: filt.subCat,
            _id: filt.filt,
          }).then(() => {
            this.clearFilter();
            this.$toasted.show("Filter updated");
          });
        }
      }
    },
    addToAnnotations(element) {
      EventBus.$emit("showDetail", element);
      this.activeBlock = {
        item: element,
        index: _.findIndex(this.form.query, element),
      };
      this.annotationsVisible = true;
    },
    addToIndicesDetail(element) {
      this.indiceDetailVisible = true;
      if (["Year", "Field"].includes(element.typeName)) {
        this.activeIndice = {
          name: element.typeName,
          type: element.typeName.toLowerCase(),
        };
      } else {
        this.activeIndice = this.indices.find(
          (i) => i.name === element.typeName
        );
      }
      this.activeBlock = {
        item: element,
        index: _.findIndex(this.form.query, element),
      };
      EventBus.$emit("indiceDetail", element);
    },
    submit() {
      if (!this.activeFilter) {
        this.modalFilter = preFilter(this.form.query);
        this.$bvModal.show("new-filter-modal");
      } else {
        this.modalFilter = this.activeFilter;
        this.activeFilter = preFilter(this.form.query);
        //this.$bvModal.show("new-filter-modal");
        this.$bvModal.show("modal-filter-edit");
      }
    },
    wikiToFilter(wiki){
      this.modalFilter = wiki;
      this.$bvModal.show("new-filter-modal");
    },
    saveBlock(topics) {
      let blockThemes = [];
      let conceptNames = [];
      let blockValues = [];
      let blockTopics = [];
      _.each(topics, (topic) => {
        _.each(topic.children, (theme) => {
          _.each(theme.children, (concept) => {
            if (concept.checked) {
              blockValues.push(concept.id);
              conceptNames.push(concept.name);
              blockThemes.push(concept.theme_id);
              blockTopics.push(concept.topic_id);
            }
          });
        });
      });
      if (this.activeBlock.item.value.includes("TTC_XXX")) {
        conceptNames = conceptNames.concat(this.getUnMatched().names);
        blockValues = blockValues.concat(this.getUnMatched().ids);
      }
      this.form.query.splice(this.activeBlock.index, 1, {
        display: conceptNames.join(),
        id: moment().format("x") + Math.floor(Math.random() * 100),
        info: conceptNames,
        source: "concept",
        theme: blockThemes,
        topic: blockTopics,
        type: "ttc-concept",
        typeName: "TTC Concept",
        value: blockValues,
      });
      if (blockValues.length === 0) {
        if(!this.annotationsVisible){
          this.form.query.splice(this.activeBlock.index, 1);
          this.activeBlock = null;
        }
      }
      this.loadFreshDocs();
    },
    getUnMatched() {
      let unmatched = { ids: [], names: [] };
      this.activeBlock.item.value.forEach((con, n) => {
        if (con === "TTC_XXX") {
          unmatched.ids.push(con);
          unmatched.names.push(this.activeBlock.item.info[n]);
        }
      });
      return unmatched;
    },
    saveIndice(indices) {
      let names = [];
      let values = [];
      _.each(indices, (indice) => {
        names.push(indice.name);
        values.push(indice.value);
      });
      this.form.query.splice(this.activeBlock.index, 1, {
        display: names.join(),
        id: moment().format("x") + Math.floor(Math.random() * 100),
        info: names,
        type: this.activeBlock.item.type,
        typeName: this.activeBlock.item.typeName,
        value: values,
      });
      if (names.length === 0) {
        this.form.query.splice(this.activeBlock.index, 1);
        this.activeBlock = null;
      }
      this.loadFreshDocs();
    },
    loadFreshDocs() {
      // Add selection
      let selection = [];
      let query = preFilter(this.form.query);
      selection = prepFilter(query, this.filterFocused.rawquery);
      if (selection.length === 0) {
        this.subsetFilter.length > 0
          ? (selection = this.subsetFilter)
          : (selection = []);
      }
      this.saveFilterQuery({ query: selection });
    },
    /**
     * Keeps only _id (and name) to create selection for filtering
     *
     * @param selection
     */
    filterOutIdName(selection) {
      if (!Array.isArray(selection)) {
        if (typeof selection === "string") {
          // Operator
          return selection;
        }
        return { _id: selection._id, name: selection.name };
      } else {
        let res = [];
        selection.forEach((sel) => {
          res.push(this.filterOutIdName(sel));
        });
        return res;
      }
    },
    saveImportedFilter(cat, subcat, filt) {
      let catfound = _.find(this.filters, { name: cat.name });
      let category = null;
      let subcategory = null;
      let filter = {
        name: filt.name,
        query: filt.rawquery,
        type: "filter",
      };
      if (catfound) {
        category = { _id: catfound._id };
        let subcatfound = _.find(catfound.children, { name: subcat.name });
        if (subcatfound) {
          subcategory = { _id: subcatfound._id };
          let filtfound = _.find(subcatfound.children, { name: filter.name });
          if (filtfound) {
            filter.name =
              filtfound.name + "_" + Math.random().toString().slice(-3, -1);
          }
        } else {
          subcategory = { name: subcat.name };
        }
      } else {
        category = { name: cat.name };
        subcategory = { name: subcat.name };
      }
      this.saveFilter({
        filter: filter,
        category: category,
        subcategory: subcategory,
      }).then(() => {
        
        this.$toasted.show("Filter saved with name " + filter.name);
      });
    },
    saveInvalidFilter(cati, subi, filti) {
      let fname =
        this.importedFilters[cati].children[subi].children[filti].name;
      let frawquery =
        this.importedFilters[cati].children[subi].children[filti].rawquery;
      let fcleanquery = this.cleanQuery(frawquery);
      let ftype =
        this.importedFilters[cati].children[subi].children[filti].type;
      let lfilter = null;
      let cat = getFiltId(this.filters, this.importedFilters[cati].name);
      let subcat = null;
      if (cat) {
        subcat = getFiltId(
          this.filters[cat.ind].children,
          this.importedFilters[cati].children[subi].name
        );
        if (subcat === null) {
          let data = {
            filter: {},
            category: {
              _id: cat.id,
            },
            subcategory: {
              name: this.importedFilters[cati].children[subi].name,
            },
          };
          this.saveCategory(data).then((res) => {
            if (fcleanquery.length > 0) {
              let filter = {
                name: fname,
                query: fcleanquery,
                type: "filter",
              };
              this.saveFilter({
                filter: filter,
                category: { _id: cat.id },
                subcategory: { _id: res.subcategory },
              }).then((resp) => {
                lfilter = resp._id;
                this.saveSecondaryFilter({
                  linkedfilter: lfilter,
                  name: fname,
                  rawquery: frawquery,
                  type: ftype,
                  category: cat.id,
                  subcategory: res.subcategory,
                }).then((res) => {
                  this.$toasted.show("Filter saved");
                });
              });
            } else {
              this.saveSecondaryFilter({
                name: fname,
                rawquery: frawquery,
                type: ftype,
                category: cat.id,
                subcategory: res.subcategory,
              }).then((res) => {
                this.$toasted.show("Filter saved");
              });
            }
          });
        } else {
          if (fcleanquery.length > 0) {
            let filter = {
              name: fname,
              query: fcleanquery,
              type: "filter",
            };
            this.saveFilter({
              filter: filter,
              category: { _id: cat.id },
              subcategory: { _id: subcat.id },
            }).then((res) => {
              lfilter = res._id;
              this.saveSecondaryFilter({
                linkedfilter: lfilter,
                name: fname,
                rawquery: frawquery,
                type: ftype,
                category: cat.id,
                subcategory: subcat.id,
              }).then((res) => {
                this.$toasted.show("Filter saved");
              });
            });
          } else {
            this.saveSecondaryFilter({
              name: fname,
              rawquery: frawquery,
              type: ftype,
              category: cat.id,
              subcategory: subcat.id,
            }).then((res) => {
              this.$toasted.show("Filter saved");
            });
          }
        }
      } else {
        let data = {
          filter: {},
          category: {
            name: this.importedFilters[cati].name,
          },
          subcategory: {
            name: this.importedFilters[cati].children[subi].name,
          },
        };
        this.saveCategory(data).then((res) => {
          if (fcleanquery.length > 0) {
            let filter = {
              name: fname,
              query: fcleanquery,
              type: "filter",
            };
            this.saveFilter({
              filter: filter,
              category: { _id: res.category },
              subcategory: { _id: res.subcategory },
            }).then((resp) => {
              lfilter = resp._id;
              this.saveSecondaryFilter({
                linkedfilter: lfilter,
                name: this.importedFilters[cati].children[subi].children[filti]
                  .name,
                rawquery:
                  this.importedFilters[cati].children[subi].children[filti]
                    .rawquery,
                type: this.importedFilters[cati].children[subi].children[filti]
                  .type,
                category: res.category,
                subcategory: res.subcategory,
              }).then(() => {
                this.$toasted.show("Filter saved");
              });
            });
          } else {
            this.saveSecondaryFilter({
              name: this.importedFilters[cati].children[subi].children[filti]
                .name,
              rawquery:
                this.importedFilters[cati].children[subi].children[filti]
                  .rawquery,
              type: this.importedFilters[cati].children[subi].children[filti]
                .type,
              category: res.category,
              subcategory: res.subcategory,
            }).then(() => {
              this.$toasted.show("Filter saved");
            });
          }
        });
      }
    },
    async saveSelectedImpFilters(){
      this.loadAnimStart();
      this.saveLoadingStep("Saving.....");
      let payloadList = [];
      let itr = 0;
      this.selectedFiltersForImport.forEach(async (impFilt, itr) => {
        const cat = impFilt.cat;
        const subcat = impFilt.subcat;
        const filt = impFilt.filter;
        const cati = impFilt.ci;
        const subi = impFilt.si;
        const filti = impFilt.fi;
        if(filt.unmatched === 0){
          let catfound = _.find(this.filters, { name: cat.name });
          let category = null;
          let subcategory = null;
          let filter = {
            name: filt.name,
            query: filt.rawquery,
            type: "filter",
          };
          if (catfound) {
            category = { _id: catfound._id };
            let subcatfound = _.find(catfound.children, { name: subcat.name });
            if (subcatfound) {
              subcategory = { _id: subcatfound._id };
              let filtfound = _.find(subcatfound.children, { name: filter.name });
              if (filtfound) {
                filter.name =
                  filtfound.name + "_" + Math.random().toString().slice(-3, -1);
              }
            } else {
              subcategory = { name: subcat.name };
            }
          } else {
            category = { name: cat.name };
            subcategory = { name: subcat.name };
          }
          payloadList.push({
            filter: filter,
            category: category,
            subcategory: subcategory,
            name: null,
            rawquery: null,
            type: null
          });
        }
        else if(filt.matched !== 0){
          let fname =
            this.importedFilters[cati].children[subi].children[filti].name;
          let frawquery =
            this.importedFilters[cati].children[subi].children[filti].rawquery;
          let fcleanquery = this.cleanQuery(frawquery);
          let ftype =
            this.importedFilters[cati].children[subi].children[filti].type;
          
                  let filter = {
                    //name: filtfound? fname + "_" + Math.random().toString().slice(-3, -1):fname,
                    name: fname,
                    query: fcleanquery,
                    type: "filter",
                  };

                  payloadList.push({
                    filter: filter,
                    //category: catfound? { _id: catfound.id }:{ name: this.importedFilters[cati].name },
                    //subcategory: subcatfound? { _id: subcatfound.id }: { name: this.importedFilters[cati].children[subi].name },
                    //name: filtfound? fname + "_" + Math.random().toString().slice(-3, -1):fname,
                    category: { name: this.importedFilters[cati].name },
                    subcategory: { name: this.importedFilters[cati].children[subi].name },
                    name: fname,
                    rawquery: frawquery,
                    type: ftype
                  });  

                
        }
        if(this.selectedFiltersForImport.length === itr+1){
          for (let i = 0; i < payloadList.length; i += 50) {
              this.saveLoadingStep(`Saved filters "${i}" of total "${payloadList.length}"`);
              const chunk = payloadList.slice(i, i + 50);
              await this.saveBulkImportedFilters(chunk);
              //this.saveLoadingStep(res.message);
              if(i+50 >= payloadList.length){
                setTimeout(() => { this.saveLoadingStep(""); this.loadAnimEnd() }, 1000);
                this.selectedFiltersForImport = [];
              }
          }
        }
      })
    },
    cleanQuery(rq) {
      let cq = [];
      rq.forEach((el) => {
        if (el !== "OR" && el._id !== "TTC_XXX") {
          cq.push(el);
          cq.push("OR");
        }
      });
      cq.pop();
      return cq;
    },
    parseImportedFilter(filtElem, cat, sub, filt) {
      this.activeFilter = filtElem;
      this.impFiltInEdit = {
        category: cat,
        subcategory: sub,
        filter: filt,
      };
      this.filterToView(filtElem.rawquery);
    },
    parseQueryElements(filtElem, allowBrackets = true) {
      if (!Array.isArray(filtElem)) {
        filtElem = [filtElem];
      }
      if (filtElem.length > 1 && allowBrackets) {
        this.addOperatorToQuery("bracket_open");
      }
      for (let c = 0; c < filtElem.length; c++) {
        let element = filtElem[c];
        let nextC = c + 1;
        let nextNextC = c + 2;
        let expand = true;
        let multiple = [element];
        while (expand && !Array.isArray(element)) {
          let nextElement = filtElem[nextC] || null;
          let nextNextElement = filtElem[nextNextC] || null;
          expand = false;
          if (nextElement && nextNextElement) {
            if (nextElement === "OR" && nextNextElement.type === element.type) {
              multiple.push(nextNextElement);
              c += 2;
              nextC += 2;
              nextNextC += 2;
              expand = true;
            }
          }
        }
        if (multiple.length > 1) {
          // Add multiple elements as a block
          this.filterToView(multiple);
        } else {
          if (element !== null) {
            if (typeof element === "string") {
              this.addOperatorToQuery(element);
            } else if (Array.isArray(element)) {
              this.parseQueryElements(element);
            } else {
              if ("info" in element) {
                if (element.info === "Indice") {
                  this.addToQuery(element.type, [element]);
                }
              }
              if ("type" in element) {
                if (element.type === "Field") {
                  this.addToQuery(element.type, [element]);
                } else if (_.find(this.indices, { name: element.type })) {
                  this.addToQuery(element.type, [element]);
                } else {
                  this.filterToView(element);
                }
              }
            }
          }
        }
      }
      if (filtElem.length > 1 && allowBrackets) {
        this.addOperatorToQuery("bracket_close");
      }
    },
    addToQuery(type, arr) {
      let typeName;
      let display;
      let info;
      let isIndice;
      if (type === "field") {
        isIndice = true;
        typeName = "Field";
        display = arr.map((a) => a.name).join(", ");
        info = arr.map((a) => a.name);
      } else if (
        type === "filter" ||
        type === "ttc-theme" ||
        type === "ttc-concept"
      ) {
        typeName = "Filter";
        if (type === "ttc-theme") {
          typeName = "TTC Theme";
        }
        if (type === "ttc-concept") {
          typeName = "TTC Concept";
        }
        display = arr.map((a) => a.title).join(", ");
        info = arr.map((a) => a.name);
      } else {
        isIndice = true;
        //typeName = this.indices.find(i => i.name === type || i.type === type).name;
        typeName = arr[0].type;
        display = arr.map((a) => a.name).join(", ");
        info = arr.map((a) => a.name);
      }
      this.form.query.push({
        id: moment().format("x") + Math.floor(Math.random() * 100),
        type: type,
        typeName: typeName,
        value: isIndice ? arr.map((a) => a._id) : arr.map((a) => a.id),
        display: display,
        info: info,
        topic: isIndice ? null : arr.map((a) => a.topic_id),
        theme: isIndice ? null : arr.map((a) => a.theme_id),
      });
      this.loadFreshDocs();
    },
    addOperatorToQuery(val) {
      this.form.query.push({
        id: moment().format("x") + Math.floor(Math.random() * 100),
        type: "operator",
        value: val,
        display: this.buttons.find((b) => b.value === val).display,
      });
    },
    openModal(modal) {
      this.$bvModal.show("modal-" + modal);
    },
    openIndiceModal(indice) {
      this.modalIndice = indice;
      this.$bvModal.show("modal-indice");
    },
    setBlock(type) {
      if (type === "filter" || type === "ttc-concept") {
        this.$bvModal.show("modal-" + type);
      } else if (type === "field") {
        this.$bvModal.show("modal-field");
      } else {
        this.modalIndice = this.indices.find((i) => i.type === type);
        this.$bvModal.show("modal-indice");
      }
    },
    draggedSomething(e) {
      this.filterToView(e);
      this.loadFreshDocs();
    },
    filterToView(e) {
      let el = null;
      "added" in e ? (el = e.added.element) : (el = e);

      if (e && !("moved" in e)) {
        if (!Array.isArray(el)) {
          el = [el];
        }

        if (["topic", "theme", "concept"].includes(el[0].type.toLowerCase())) {
          let cons = [];
          let connames = [];
          el.forEach((it) => {
            let ttcItem = this.ttcLookup({ id: it._id || it.id });
            if (ttcItem) {
              if (ttcItem.children) {
                ttcItem.children.forEach((ttcIt) => {
                  if (ttcIt.children) {
                    ttcIt.children.forEach((ti) => {
                      cons.push(ti.id);
                      connames.push(ti.name);
                    });
                  } else {
                    cons.push(ttcIt.id);
                    connames.push(ttcIt.name);
                  }
                });
              } else {
                cons.push(ttcItem.id);
                connames.push(ttcItem.name);
              }
            } else {
              if (typeof it !== "string") {
                cons.push(it._id);
                connames.push(it.name);
              }
            }
          });

          //this.form.query.splice(-1,1)
          this.form.query.push({
            id: moment().format("x") + Math.floor(Math.random() * 100),
            type: "ttc-concept",
            typeName: "TTC Concept",
            value: cons,
            display: connames.join(),
            info: connames,
            // topic: el.id,
            source: el[0].type.toLowerCase(),
          });
        } else {
          let customType;
          if (el[0].type === "Field") {
            customType = "field";
          } else if (el[0].type === "Year") {
            customType = "year";
          } else if (el[0].type === "Userfilter") {
            customType = "filter";
          } else {
            customType = this.indices.find((i) => i.name === el[0].type).type;
          }

          this.form.query.push({
            id: moment().format("x") + Math.floor(Math.random() * 100),
            type: customType,
            typeName: el[0].type==='Userfilter'? 'Filter':el[0].type,
            value: el.map((x) => x._id),
            display: el.map((x) => x.name).join(", "),
            info: el.map((x) => x.name),
            source: customType==='filter'? "":"concept",
          });
        }
      }
      if ("moved" in el) {
        let oldVal = this.form.query[el.moved.oldIndex];
        this.form.query.splice(el.moved.oldIndex, 1);
        this.form.query.splice(el.moved.newIndex, 0, oldVal);
      }
    },
    filterMoved(e) {
      console.log("filterMoved", e.moved);
    },
    removeItemFromQuery(item) {
      if (item.type === "ttc-concept" && item.value[0] !== "TTC_XXX") {
        this.$refs.detailView.uncheckTopic(
          this.ttcLookup({ id: item.value[0] })
        );
      }
      this.form.query = this.form.query.filter((q) => q.id !== item.id);
      this.loadFreshDocs();
    },
    addToFocus() {
      let filterToApply = {
        name: "Filter Query",
        rawquery: [filterOutIdName(preFilter(this.form.query))],
      };
      console.log(this.form.query);
      this.filterFocus({ filter: filterToApply, type: "focus" }).then(() => {
        if (this.$route.name !== "ExploreDiscover") {
          this.$router.push({ name: "ExploreDiscover" });
        }
      });
    },
    clearFilter(preventReload = false) {
      this.form.query.forEach((item) => {
        if (item.type === "ttc-concept" && item.value[0] !== "TTC_XXX") {
          this.$refs.detailView.uncheckTopic(
            this.ttcLookup({ id: item.value[0] })
          );
        }
      });
      this.updateBtnVisible = false;
      this.form.query = [];
      this.activeFilter = null;
      this.modalFilter = null;
      this.activeIndice = null;
      this.activeBlock = null;
      if (!preventReload) {
        this.loadFreshDocs();
      }
    },
    handleMisMatched(parent) {
      this.activeFilter = this.modalFilter;
      this.activeFilter.maincat = parent;
      this.mergeConflicts = true;
    },
    discardNew() {
      this.filters.forEach((cat) => {
        if (cat._id === this.activeFilter.maincat) {
          cat.children.forEach((subcat) => {
            if (subcat._id === this.activeFilter.parent_id) {
              subcat.children.forEach((filt) => {
                if (filt._id === this.activeFilter._id) {
                  this.activeFilter = filt;
                  this.mergeConflicts = false;
                }
              });
            }
          });
        }
      });
    },
    discardOld() {
      this.filters.forEach((cat) => {
        if (cat._id === this.activeFilter.maincat) {
          cat.children.forEach((subcat) => {
            if (subcat._id === this.activeFilter.parent_id) {
              subcat.children.forEach((filt) => {
                if (filt._id === this.activeFilter._id) {
                  this.reverseQuery(filt);
                  this.activeFilter = filt;
                  this.mergeConflicts = false;
                }
              });
            }
          });
        }
      });
    },
    reverseQuery(fl) {
      this.form.query = [];
      this.parseQueryElements(fl.rawquery, false);
      setTimeout(() => {
        this.loadFreshDocs();
      }, 0);
    },
    jumpToFilterFocused() {
      let activeId = this.filterFocused._id;

      if (this.filterFocusedType === "filter") {
        this.activeTab = 0;
      } else if (this.filterFocusedType === "wiki") {
        this.activeTab = 1;
      }

      _.each(this.filterFocusedType, (f) => {
        // Check if category contains active filter
        let openCategory = _.filter(f.children, (c) => c._id === activeId);
        if (openCategory.length) {
          f.open = true;
          return false;
        }
        _.each(f.children, (fc) => {
          // Check if category's children contains active filter
          let openSubcategory = _.filter(
            fc.children,
            (c) => c._id === activeId
          );
          if (openSubcategory.length) {
            fc.open = true;
            f.open = true;
            return false;
          }
        });
      });

      Vue.nextTick(() => {
        // TODO: Persist scroll in vue-virtual-scroll-list
        let element = $(
          `#${this.filterFocusedType}-subcategory-item-${activeId}`
        );

        if (element.length > 0) {
          $("#explore-sidebar").animate(
            { scrollTop: $(element[0]).offset().top - 100 },
            200
          );

          element.addClass("highlight");
          window.setTimeout(() => {
            element.removeClass("highlight");
          }, 1400);
        }
      });
    },
    getFilters(ids) {
      this.exportFilters = [];
      this.unExportable = 0;
      ids.forEach((id) => {
        //this.filtersTemp.forEach(filtcat => {
        this.filters.forEach((filtcat) => {
          let cat = filtcat.name;
          filtcat.children.forEach((filtsubcat) => {
            let subcat = filtsubcat.name;
            let filter = _.find(
              filtsubcat.children,
              (filter) => filter._id === id
            );
            if (filter) {
              if(filter.rawquery){
                let cons = this.parseQuery(filter.rawquery);
                if (cons.length > 0) {
                  this.exportFilters.push({
                    Category: cat,
                    Subcategory: subcat,
                    Filtername: filter.name,
                    Concepts: cons.join(" | "),
                  });
                } else {
                  this.unExportable += 1;
                }
              }
            }
          });
        });
      });
    },
    parseQuery(query) {
      let concepts = [];
      query.forEach((el) => {
        if (Array.isArray(el)) {
          el.forEach((e) => {
            if (typeof e === "object" && e.type === "Concept") {
              concepts.push(e);
            }
          });
        }
        if (typeof el === "object" && el.type === "Concept") {
          concepts.push(el);
        }
      });
      return concepts.map(function (con) {
        return '"' + con.name + '"';
      });
    },
    selectionTask(select){ 
      return new Promise((resolve, reject) => {
        if(select){
          this.addFiltersToExport([]);
          let filterIds = [];
          this.filters.forEach((filtcat, c) => {
            filtcat.children.forEach((filtsubcat, s) => {
              filtsubcat.children.forEach((filter, f) => {
                if(!filtcat.name.includes("_del") && !filtsubcat.name.includes("_del") && !filter.name.includes("_del") && !filter._id.includes("invalid")){
                  filterIds.push(filter._id);
                }
                if(this.filters.length === c+1 && filtcat.children.length === s+1 && filtsubcat.children.length === f+1){
                  this.addFiltersToExport(filterIds);
                  resolve();
                }
              });        
            });
          });
        }
        else{
          this.addFiltersToExport([]);
          resolve();
        }
      })
    },
    selectAllFilters(select) {
      this.saveLoadingStep("Working on selections...");
      this.loadAnimStart();
      this.selectionTask(select).then(() => {
        this.saveLoadingStep("");
        this.loadAnimEnd();
      });
    },
    countFilters() {
      if(this.filterCount === 0){
        this.filters.forEach((filtcat) => {
          filtcat.children.forEach((filtsubcat) => {
            this.filterCount += _.size(filtsubcat.children);
          });
        });
      }
    },
    checkItem(item) {
      let color = "";
      if (item.includes("TTC_XXX")) {
        color = "pf";
      }
      if (item.length > 1 && _.uniq(item).length === 1) {
        color = "nf";
      }
      return color;
    },
    deleteSelectedFilter(){
      this.loadAnimStart();
      this.saveLoadingStep("Deleting selected filters...");
      this.deleteBulkFilter({ filters: this.filtersToExport }).then(() => {
        this.saveLoadingStep("Deletion Complete");
        this.addFiltersToExport([]);
        this.loadAnimEnd();
        this.saveLoadingStep("");
      })
    },
    toggleExploreSidebarSize(){
      this.saveFilterSidebarSize(!this.filterSidebarSized);
    }
  },
};
</script>
